import { getGA4Context } from '../../helpers';
import { tracker } from '../track';
export const trackDeselectFilter = ({ element, context, filterLvl, filtersValue, length, campaignId, }) => {
    const deselectFilter = {
        context: context || getGA4Context(),
        element,
        filter_lvl: filterLvl === 0 ? 0 : filterLvl || null,
        filters_value: filtersValue,
        length: length || null,
        promotion_id: campaignId || null,
    };
    tracker.track('GA4-deselect_filter', {
        event_name: 'deselect_filter',
        deselect_filter: deselectFilter,
    });
};
